import * as React from "react";
import { ThemeProvider } from "styled-components";
import Body from "@/components/core-blocks/Body";
import CookieConsent from "@/components/core-blocks/CookieConsent";
import Footer from "@/components/core-blocks/Footer";
import Header from "@/components/core-blocks/Header";
import Main from "@/components/core-blocks/Main";
import Seo, { SEOProps } from "@/components/core-blocks/Seo";
import Flexible, { IFlexible } from "@/src/components/core-blocks/Flexible";
import GlobalStyle from "@/styles/global";
import defaultTheme from "@/styles/themes/default.theme";
import Cookies from "js-cookie";
import { Script } from "gatsby";
import { BreadCrumbProps } from "@/components/global-components/Breadcrumbs";
import PasswordProtect from "@/components/global-components/PasswordProtect";

export type IPageTemplate = {
  pageContext: {
    flexible: IFlexible;
    seo: SEOProps;
    breadcrumb: BreadCrumbProps;
    hasPassword: boolean;
    id: string;
  };
};

const PageTemplate: React.FC<IPageTemplate> = ({ pageContext }) => {
  const [isAuthorized, setIsAuthorized] = React.useState(false);
  const [wrongPassword, setWrongPassword] = React.useState(false);

  React.useEffect(() => {
    if (pageContext.seo.breadcrumbs.length === 1) return;
  }, []);

  const handlePasswordSubmit = async (password: string) => {
    console.log("Password", password);
    console.log("process.env.GATSBY_PASSWORD", process.env.GATSBY_PASSWORD);

    if (password === process.env.GATSBY_PASSWORD) {
      setIsAuthorized(true);
    } else {
      console.log("Password is incorrect");
      setWrongPassword(true);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyle />
      <Body>
        <Header />
        <Main>
          {pageContext.hasPassword && !isAuthorized ? (
            <PasswordProtect
              onSubmit={handlePasswordSubmit}
              wrongPw={wrongPassword}
            />
          ) : (
            <>
              {isAuthorized && (
                <Flexible
                  components={pageContext.flexible.components}
                  breadcrumb={pageContext.breadcrumb}
                />
              )}
            </>
          )}
          {!pageContext.hasPassword && (
            <Flexible
              components={pageContext.flexible.components}
              breadcrumb={pageContext.breadcrumb}
            />
          )}
          <Footer />
          <CookieConsent />
        </Main>
      </Body>
    </ThemeProvider>
  );
};

export default PageTemplate;

// eslint-disable-next-line require-jsdoc
export function Head({ pageContext }: IPageTemplate) {
  const cookieValue = Cookies.get("cookieConsent");

  return (
    <>
      {cookieValue === "true" && (
        <Script>
          {`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${process.env.GATSBY_GTM_ID}');
    `}
        </Script>
      )}
      <html lang="sv" />
      <Seo {...pageContext.seo} lang="sv" />
    </>
  );
}
